import { CardView } from "common/views/card/Card.view";
import { Fragment } from "core/components/FragmentProvider";
export const card: Fragment<any> = {
	name: "Card",
	component: ({ children }) => (
		<CardView viewKey="articleContributorList.item">{children}</CardView>
	),
};



// WEBPACK FOOTER //
// ./src/panels/articleDetails/article/itemContainerFragments.tsx